export default class XeroInvoiceSearchModel {
  public invoiceNumber!: string | null;
  public page!: number;
  public status!: number[];

  constructor() {
    this.invoiceNumber = null;
    this.status = [];
    this.page = 1;
  }
}
